import styled, { css } from 'styled-components';

export const Wrapper = styled.ul(
  ({ theme: { admanColors } }) => css`
    z-index: 1;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(0%, 100%);
    box-shadow: 0 0 8px -2px rgb(23 29 35 / 25%);
    border-radius: 8px;
    background-color: ${admanColors!.gray.light.bg0[0]};
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
  `
);

export const Item = styled.li(
  ({ theme: { spacers, admanColors } }) => css`
    display: block;
    height: 45px;
    line-height: 45px;
    width: 90px;
    padding: 0 ${spacers!.spacer04};
    color: ${admanColors!.blue.dark.bg1[0]};

    &:not(:last-child) {
      border-bottom: 1px solid ${admanColors!.gray.light.bg3[2]};
    }

    &:hover {
      background-color: ${admanColors!.gray.light.fg[6]};
      color: ${admanColors!.gray.dark.fg1[2]};
    }
  `
);
